//The file that contains all other components and renders the app

// imports
import React from 'react'; //react library
import ReactDOM from 'react-dom'; //react DOM controls for rendering
import {App} from './App'; // app class component to render
import reportWebVitals from './utils/reportWebVitals'; // web vital reporting

// render statement
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
